import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=3b2f9d5c&scoped=true&"
import script from "./Transfer.vue?vue&type=script&lang=ts&"
export * from "./Transfer.vue?vue&type=script&lang=ts&"
import style0 from "./Transfer.vue?vue&type=style&index=0&id=3b2f9d5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f9d5c",
  null
  
)

export default component.exports